import { LoggedUser } from "redux/store";

export const hasRole = (loggedUser: LoggedUser, roleName:string) => loggedUser.roles.find(role => role.name == roleName) != null

export const hasPersonPermission = (loggedUser: LoggedUser, permissionIdentifier: string) => loggedUser.personInformation.permissions.find(permission => permission.identifier == permissionIdentifier) != null